import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav style={{
      backgroundColor: '#fffef2',
      borderBottom: '1px solid #bcbbb4',
      padding: '20px 0',
      position: 'sticky',
      top: 0,
      zIndex: 100
    }}>
      <div className="container" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '14px'
        }}>
          <a
            href="https://wa.me/919310411196"
            target="_blank"
            rel="noreferrer"
            className="body-small orders-contact"
            style={{
              color: '#1f5130',
              backgroundColor: '#d8f3dc',
              border: '1px solid #95d5b2',
              textDecoration: 'none',
              padding: '6px 10px',
              fontWeight: '600'
            }}
          >
            Orders contact 93104-11196 on WhatsApp
          </a>

          {/* Logo */}
          <Link to="/" style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none'
          }}>
            <img 
              src="https://customer-assets.emergentagent.com/job_amazon-products-3/artifacts/i004pfs7_logowithr%20600%20x%20180.jpeg" 
              alt="EASY2HOME" 
              style={{
                height: '40px',
                width: 'auto'
              }}
            />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '32px'
        }} className="desktop-nav">
          <Link to="/" className="navigation-text" style={{
            padding: '12px 0',
            position: 'relative'
          }}>
            Home
          </Link>
          <Link to="/products" className="navigation-text" style={{
            padding: '12px 0',
            position: 'relative'
          }}>
            Products
          </Link>
          <Link to="/about" className="navigation-text" style={{
            padding: '12px 0',
            position: 'relative'
          }}>
            About
          </Link>
          <Link to="/contact" className="navigation-text" style={{
            padding: '12px 0',
            position: 'relative'
          }}>
            Contact
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="mobile-menu-btn"
          style={{
            display: 'none',
            background: 'none',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          {isMenuOpen ? <X size={24} color="#333333" /> : <Menu size={24} color="#333333" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="mobile-nav" style={{
          display: 'none',
          flexDirection: 'column',
          gap: '16px',
          padding: '24px 40px',
          backgroundColor: '#f6f5e8',
          marginTop: '20px'
        }}>
          <Link to="/" className="navigation-text" onClick={() => setIsMenuOpen(false)}>
            Home
          </Link>
          <Link to="/products" className="navigation-text" onClick={() => setIsMenuOpen(false)}>
            Products
          </Link>
          <Link to="/about" className="navigation-text" onClick={() => setIsMenuOpen(false)}>
            About
          </Link>
          <Link to="/contact" className="navigation-text" onClick={() => setIsMenuOpen(false)}>
            Contact
          </Link>
        </div>
      )}

      <style>{`
        @media (max-width: 1024px) {
          .desktop-nav {
            display: none !important;
          }

          .orders-contact {
            display: none !important;
          }
          
          .mobile-menu-btn {
            display: block !important;
          }
          
          .mobile-nav {
            display: flex !important;
          }
        }
      `}</style>
    </nav>
  );
};

export default Navigation;
